import http from '@sinolink/http'
import { PayOptions } from '../types/WebPayTypes'
import api from './api'
import { signPreOrderWithMd5 } from '../../tools/utils'

/**
 *  统一下单接口
 * @param data
 * @returns
 */
export const getPreOrder = async (params: PayOptions) => {
  let _params: any = params

  if (params.skip_pre_order) {
    return {
      code: 0,
      result: params.pre_order_result
    }
  }

  const data = await getSystemTime()

  if (data.code === 0) {
    _params.timestamp = data.result
  } else {
    _params.timestamp = String(Date.now())
  }

  // 注意 优惠券和订单失效的key值，微信与支付宝不同
  if (Number(params.pay_type) === 1) {
    if (params.promo_params) {
      _params.goods_tag = params.promo_params
      delete _params.promo_params
    }

    if (params.timeout_express) {
      _params.time_expire = params.timeout_express
      delete _params.timeout_express
    }
  }
  _params.sign = signPreOrderWithMd5(_params)
  return http.get(api.preOrder, { params: _params })
}

/**
 * 获取服务器时间戳
 */
export function getSystemTime() {
  return http.get(api.getSysTime)
}
